import { COMPLIANCE_REQUESTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/compliance_requests_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'buyerComplianceRequestsIndex',
	// Backs the Overview "Request" async-select filter.
	'complianceOverviewRequestFilter',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
